

const ForecastHeader = () => {
  return (
    <div className="mb-4">
      <h2 className="text-2xl font-bold text-gray-900">Forecast Month Stock</h2>
      <p className="text-gray-600 mt-1">Analyze stock forecasts and month coverage by region and category</p>
    </div>
  );
};

export default ForecastHeader;
